<template>
  <div class="modal_container">
    <div class="modal_wrapper">
      <div
        class="modal_background"
        @click.self="$store.commit('toggleRecordModalState', 'reviewModal')"
        tabindex="0"
        id="modal_background"
      ></div>
      <div class="modal_record_component">
        <button
          class="close-popup"
          @click.stop="$store.commit('toggleRecordModalState', 'reviewModal')"
        >
          <span></span>
          <span></span>
        </button>
        <div class="review">
          <div class="modal_header">
            <div class="modal_header__text">
              <h3>
                Оставить отзыв
              </h3>
            </div>
            <p>
              Ваш отзыв будет опубликован и доступен для просмотра другим
              пользователям. Спасибо!
            </p>
          </div>
          <div class="input-group-wrapper" style="display: block">
            <div
              class="input-group"
              style="grid-gap: 20px; display: flex !important;"
            >
              <default-input-modal
                maska=""
                v-model="nameValue"
                type="text"
                placeholder="Ваше имя*"
                :class="{ error: error['name'] }"
              />
              <default-input-modal
                v-model="mailValue"
                type="text"
                placeholder="Электронная почта (необъязательно)"
                class="noreq"
                :class="{ error: error['email'] }"
              />
              <default-text-area-modal
                :rows="4"
                placeholder="Текст вопроса"
                type="text"
                v-model="textValue"
                :class="{ error: error['text'] }"
              />
            </div>
            <p
              style="text-align: center; margin-top: 30px; font-weight: bold; font-size: 18px; line-height: 22px;"
            >
              Оцените услуги МДЦ «ПРОЗДОРОВЬЕ»
            </p>
            <modal-star
              style="display: flex; justify-content: center; margin-top: 10px;"
              @startStateUpdate="toggleRating"
            ></modal-star>
            <div style="display: flex; justify-content: center;">
              <button
                @click="sendReview"
                type="submit"
                class="popup__submit"
                id="postReviewModal"
              >
                <p>
                  Отправить
                </p>
              </button>
            </div>
            <div class="start__footer" style="order: 8;">
              Заполняя форму, Вы соглашаетесь с<br /><a
                :href="policy"
                target="_blank"
                >политикой конфиденциальности</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DefaultInputModal from "../select/DefaultInputModal.vue";
import DefaultTextAreaModal from "../select/DefaultTextAreaModal.vue";
import ModalStar from "./ModalStar.vue";
import { api } from "../../store/api";
export default {
  name: "ReviewModal",
  components: {
    DefaultInputModal,
    DefaultTextAreaModal,
    ModalStar,
  },
  data() {
    return {
      nameValue: "",
      textValue: "",
      mailValue: "",
      ratingValue: 1,
      policy: "policy",
      error: {},
    };
  },
  methods: {
    toggleRating(index) {
      this.ratingValue = index;
    },

    sendReview() {
      const postObject = {
        name: this.nameValue,
        text: this.textValue,
        email: this.mailValue,
        rating: this.ratingValue,
        is_moderated: false,
      };
      api.fetch("POST", "reviews/", postObject).then((res) => {
        if (res?.id) {
          this.$store.commit("toggleRecordModalState", "reviewModal");
          this.$store.commit("toggleMessageModalText", "Ваш отзыв отправлен!");
          if (!this.$store.state.messageModal.stateActiveModal) {
            this.$store.commit("showMessageModalState");
          }
          this.error = {};
          this.nameValue = "";
          this.textValue = "";
          this.mailValue = "";
          this.$store.dispatch("ACTION__REVIEWS");
        } else {
          this.$store.commit(
            "toggleMessageModalText",
            "Проверьте поля на корректность ввода!"
          );
          this.$store.commit("showMessageModalState");
          this.error = res;
        }
      });
    },
  },
  computed: {
    servicesList() {
      return this.$store.state?.servicesList;
    },
  },
  watch: {},
};
</script>
<style scoped lang="scss" src="./modal.scss"></style>
